<template>
    <form method="POST" :action="route">
        <input type="hidden" name="_token" :value="token">
            <table class="abc-table mx-auto text-center" style="width:100%;">
                <thead class="abc-title-table">
                    <tr style="border-bottom: 3px solid #1e1e1e; font-size: 12px!important;">
                        <th class="py-3" style="width: 14%; vertical-align: middle; color: #1e1e1e;">{{__("traductionview.Country")}}</th>
                        <th style="width: 14%; vertical-align: middle; color: #1e1e1e;">{{__("traductionview.removecountry")}}</th>
                    </tr>
                </thead>
                <tbody class="text-center" style="font-size: 11px; max-height: 600px; overflow: auto; display: block;">
                    <tr v-for="(project, index) in customs" :key="index" style="border-bottom: 1px solid rgba(30, 30, 30, .1);">
                        <input type="hidden"
                            :name="'form[' + index + '][customer]'"
                            :value="customer.id ">
                        <td v-if="project.existing==1" class="py-3 px-2" style="vertical-align: middle; width:14%;">
                            {{ project.name }}
                        </td>
                        <td v-else class="px-2" style="vertical-align: middle; width:14%;">
                            <select
                                class="form-control-4"
                                style="font-size:11px; width:100%; text-transform:capitalize;"
                                v-model="country">
                                <option value="null" disabled>{{__("traductionview.selectcountry")}}</option>
                                <option v-for="country in countries" :key="country.id" :value="country">{{ country.name }}</option>
                            </select>

                            <input type="hidden"
                                style="font-size:11px;"
                                :name="'form[' + index + '][country]'"
                                :value="country.id ">
                        </td>
                        <td v-if="project.existing==1" class="px-2" style="vertical-align: middle; width:14%;">
                            <a :href="'/select_country/pro/delete/'+project.id+'/'+customer.id" class="btn btn-abc" style="padding: 10px;">
                                <p class="mb-0">Delete this country</p>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        <div class="row justify-content-center" style="padding-bottom: 20px;">
            <div class="col-md-6 px-4 my-3">
                <div class="mr-auto" style="width: max-content;">
                    <button type="button" class="btn-abc" style="padding:10px;" v-on:click="addRaw">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle mr-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                        </svg>
                        {{__("traductionview.ajouterpayer")}}

                    </button>
                </div>
            </div>
            <div class="col-md-6 px-4 my-3">
                <div class="ml-auto" style="width: max-content;">
                    <button type="submit" class="btn-abc-green triggerspinner" style="padding: 10px; font-weight: 700!important;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-check-circle mr-2" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                        </svg>
                          {{__("traductionview.updatecountries")}}
                    </button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        props: [
            'customer',
            'user',
            'countries',
            'token',
            'route',
        ],

        data() {
            return {
                form: [],
                customs:[],
                counts: [],
                country:"",
            }
        },

        mounted() {
            this.customer.country_presence.forEach(customer =>
            {
                this.customs.push(customer)
            });
        },

        methods: {

            addRaw(){
                this.customs.push(
                {
                    id: null,
                    name: null,
                    existing: 0,
                });
            }
        }
    }

</script>